<template>
    <div ref="rootElement" class="file-wrapper-multi-view-render">
        <PtIcon
            v-if="loading"
            icon="SolidLoadingBars"
            class="file-wrapper-multi-view__loading"
        />
        <div v-else-if="multiViewNodata" class="file-wrapper-multi-view__nodata">
            <PtNodata />
        </div>
        <template v-else>
            <div class="file-wrapper-multi-view__fixed">
                <div
                    class="file-wrapper-multi-view__header"
                    @mouseenter="showTabsMore = true"
                    @mouseleave="showTabsMore = false"
                >
                    <FileWrapperMultiViewInfo class="file-wrapper-multi-view__info" />
                    <FileWrapperMultiViewTabs
                        v-model="currentRound"
                        class="file-wrapper-multi-view__tabs"
                        :more="showTabsMore"
                        :list="multiViewTabList"
                    />
                </div>
            </div>
            <div
                :class="{
                    'file-wrapper-multi-view__main': true,
                    'file-wrapper-multi-view__main__nodata': currentRoundNodata
                }"
            >
                <PtNodata v-if="currentRoundNodata" class="file-wrapper-multi-view__nodata" />
                <template v-else>
                    <FileWrapperRejection
                        :key="`round__rejection__${currentRoundDetail.round}`"
                        class="file-wrapper-multi-view__main__rejection"
                    />
                    <FileWrapperApplicant
                        :key="`round__applicant__${currentRoundDetail.round}`"
                        class="file-wrapper-multi-view__main__applicant"
                    />
                </template>
            </div>
        </template>

        <PtIcon
            class="file-wrapper-multi-view__close"
            icon="SolidCloseBig"
            @click="onClose"
        />
    </div>
</template>

<script setup lang="ts">
import { ref, onUnmounted, onMounted, computed } from 'vue';
import FileWrapperMultiViewInfo from './FileWrapperMultiViewInfo.vue';
import FileWrapperMultiViewTabs from './FileWrapperMultiViewTabs.vue';
import FileWrapperRejection from './FileWrapperRejection.vue';
import FileWrapperApplicant from './FileWrapperApplicant.vue';
import useFileWrapperMultiView, { createService, destroyService } from '../../composables/use-file-wrapper-multi-view';
import { Icon as PtIcon } from 'patsnap-biz';
import _ from 'lodash';
import PtNodata from '../PtNodata.vue';
import '@patsnap-ui/icon/assets/solid/CloseBig.svg';
import '@patsnap-ui/icon/assets/solid/LoadingBars.svg';

window.rvTrack('View Patent File Wrapper Multi View');

const {
    multiViewNodata,
    multiViewTabList,
    currentRound,
    currentRoundDetail,
} = useFileWrapperMultiView();

const props = defineProps({
    patentId: {
        type: String,
        required: true,
    },
});

const rootElement = ref<HTMLElement | null>(null);

const emit = defineEmits(['close']);
const onClose = () => {
    emit('close', undefined);
};

const moveElementToBody = () => {
    if (rootElement.value) document.body.appendChild(rootElement.value);
};

const removeElementInBody = () => {
    if (rootElement.value) document.body.removeChild(rootElement.value);
};

const escapeHandler = e => {
    if (e.key === 'Escape' || e.keyCode === 27) {
        onClose();
    }
};
document.addEventListener('keydown', escapeHandler);
onMounted(() => {
    moveElementToBody();
});
onUnmounted(() => {
    document.removeEventListener('keydown', escapeHandler);
    destroyService();
    removeElementInBody();
});

const showTabsMore = ref(false);
const loading = ref(true);

createService(props.patentId)
    .then(() => {
        loading.value = false;
    });

const currentRoundNodata = computed(() => {
    return _.isEmpty(currentRoundDetail.value);
});
</script>

<style lang="scss">
.file-wrapper-multi-view-render {
    color: $text-primary;
    position: fixed;
    height: 100%;
    width: 100%;
    background: #fff;
    left: 0;
    top: 0;
    z-index: 999;
    display: flex;
    flex-direction: column;
    overflow: hidden;

    .file-wrapper-multi-view__loading {
        font-size: 48px;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .file-wrapper-multi-view__nodata {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
    }

    .file-wrapper-multi-view__fixed {
        position: relative;
        height: 84px;
        flex-shrink: 0;
    }
    .file-wrapper-multi-view__header {
        //position: relative;
        width: 100%;
        //padding: 12px 16px;
        padding-top: 8px;
        border-bottom: 1px solid $border-light;
        box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.14), 0px 0px 4px rgba(0, 0, 0, 0.08);
        background: #fff;

        // 定位元素 使得tabs的时间线能够覆盖住下面main的内容
        position: absolute;
        top: 0;
        left: 0;

    }

    .file-wrapper-multi-view__info {
        margin-right: 40px;
    }

    .file-wrapper-multi-view__tabs {
        margin-top: 8px;
    }

    .file-wrapper-multi-view__close {
        position: absolute;
        right: 16px;
        top: 12px;
        cursor: pointer;
        font-size: 24px;
        color: $fill-normal;
        //margin-left: 16px;
    }

    .file-wrapper-multi-view__main {
        flex: 1;
        display: flex;
        overflow: hidden;
        &__nodata {
            position: relative;
        }
    }

    .file-wrapper-multi-view__main__rejection {
        flex: 1;
    }

    .file-wrapper-multi-view__main__applicant {
        width: 50%;
    }
}
</style>
